import { FC, JSX } from 'react';

import Modal from '@semcore/ui/modal';

import { Button } from '@/shared';
import { stopPropagation } from '@/shared/lib/utils/stopPropagation';
import { XIcon } from '@/shared/ui/icons/svgs/16';

import s from './Modal.module.css';

interface IDeletionModalProps {
  onClose: () => void;
  onDelete: () => void;
}

const DeletionModal: FC<IDeletionModalProps> = ({
  onClose,
  onDelete,
}): JSX.Element => {
  return (
    <Modal visible closable={false}>
      <Modal.Overlay onClick={onClose}>
        <Modal.Window className={s.window} onClick={stopPropagation}>
          <Modal.Close className={s.close} onClick={onClose}>
            <XIcon />
          </Modal.Close>
          <Modal.Title className="text-center">Delete card?</Modal.Title>

          <div className="mb-6 text-center font-light">
            You can always upload it again
          </div>

          <div className="flex justify-center">
            <Button
              variant="primary"
              title="Delete"
              size="sm"
              className="mr-2 bg-red py-2"
              onClick={onDelete}
            />
            <Button
              variant="secondary"
              title="Cancel"
              size="sm"
              className="py-2"
              onClick={onClose}
            />
          </div>
        </Modal.Window>
      </Modal.Overlay>
    </Modal>
  );
};

export default DeletionModal;
